import React, { useEffect, useState } from "react";
// Reusable Components
import InputText from "../ReusableComponents/InputText";
import { mainTable } from "../css/Common";
import AddScreenTitle from "../components/AddScreenTitle";
import DropDown from "../ReusableComponents/DropDown";
import MainLayout from "../components/MainLayout";
import Buttons from "../components/Buttons";
import { GradeHeader } from "../components/HeaderAttribute";
import GridPage from "../components/GridPage";
import GradePopup from "../popup-containers/GradePopup";
import PopUpButtons from "../components/PopUpButtons";
import MainPopup from "../popup-containers/MainPopup";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
// API and Utilities
import toast from "react-hot-toast";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import Loader from "../ReusableComponents/Loader";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
const Grade = () => {
  // UI visibility states
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const createdBy = sessionStorage.getItem("createdBy");
  const clientId = sessionStorage.getItem("MstClientId");

  // popup status
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [rowIndex, setRowIndex] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [popUpDataDD, setPopUpDataDD] = useState({});
  const [popUpData, setPopUpData] = useState({});
  // Submission and loading control states
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [errors, setErrors] = useState({});

  const [MstSalaryId, setMstSalaryId] = useState("");
  const [mstGradeId, setMstGradeId] = useState("");
  // Form data & errors
  const [formFields, setformFields] = useState({
    grade: "",
    basicSalary: "",
    da: "",
    hra: "",
    Conveyance: "",
    medical: "",
    performance: "",
    others: "",
    grossSalaryTotal: "",
    pf: "",
    esi: "",
    insurance: "",
    loan: "",
    tax: "",
    deductionTotal: "",
    netTotal: "",
    mstGradeId,
  });

  const [formFieldsError, setFormFieldsError] = useState({
    GradeError: "",
    basicSalaryError: "",
    daError: "",
    hraError: "",
    ConveyanceError: "",
    medicalError: "",
    performanceError: "",
    othersError: "",
    grossSalaryTotalError: "",
    pfError: "",
    esiError: "",
    insuranceError: "",
    loanError: "",
    taxError: "",
    deductionTotalError: "",
    netTotalError: "",
  });

  const [gradeDropdown, setGradeDropdown] = useState([]);
  // Main grid data
  const [bindSalaryMasterData, setBindSalaryMasterData] = useState([]);
  const [bindGradeData, setBindGradeData] = useState([]);
  // Fetch data initially on mount
  useEffect(() => {
    BindSalaryMaster();
  }, []);
  // API call to bind Grade data
  const BindSalaryMaster = async () => {
    

    try {
      setIsLoading(true);
      const data = {
        mstClientId: clientId,
      };

      const response = await BindPostAPI(
        data,
        "SalaryMasterAPI/BindSalaryMaster"
      );

      if (response && response.data) {
        // Bind salary data to grid
        if (response.data.Table) {
           setBindSalaryMasterData(response.data.Table);
          setBindGradeData(response.data.Table2);
          console.log("Grade Data:", response.data.Table);
        } else {
          setBindSalaryMasterData([]);
          console.warn("Table not found in response");
        }

        // Bind grade dropdown
        if (response.data.Table1) {
          const gradeData = response.data.Table1.map((item) => ({
            value: item.MstGradeId,
            label: item.Grade,
          }));
          setGradeDropdown(gradeData);
        } else {
          setGradeDropdown([]);
          console.warn("Table1 (grade) not found in response");
        }
      } else {
        console.error("Empty response from API");
        setBindSalaryMasterData([]);
        setGradeDropdown([]);
      }
    } catch (error) {
      console.error("Error fetching Grade:", error);
      setBindSalaryMasterData([]);
      setGradeDropdown([]);
    } finally {
      setIsLoading(false);
    }
  };

  

  const validateForm = () => {
    let fieldErrors = {
      GradeError: "",
      basicSalaryError: "",
      daError: "",
      hraError: "",
      ConveyanceError: "",
      medicalError: "",
      performanceError: "",
      othersError: "",
      grossSalaryTotalError: "",
      pfError: "",
      esiError: "",
      insuranceError: "",
      loanError: "",
      taxError: "",
      deductionTotalError: "",
      netTotalError: "",
    };
  
    let commonErrors = {};   
  
    const gradeValue = String(formFields.grade || "").trim();
  
    
    if (!gradeValue) {
      commonErrors.grade = "Select the Grade.";
    } else if (
      !updateScreenTitle &&
      bindGradeData.some(
        (item) =>
          String(item.Grade || "").trim().toLowerCase() ===
          gradeValue.toLowerCase()
      )
    ) {
      commonErrors.grade = "Grade already exists.";
    }
  
    // Other fields
    if (!formFields.basicSalary) fieldErrors.basicSalaryError = "Enter Basic Salary.";
    if (!formFields.da) fieldErrors.daError = "Enter DA.";
    if (!formFields.hra) fieldErrors.hraError = "Enter HRA.";
    if (!formFields.Conveyance) fieldErrors.ConveyanceError = "Enter Conveyance.";
    if (!formFields.medical) fieldErrors.medicalError = "Enter Medical.";
    if (!formFields.performance) fieldErrors.performanceError = "Enter Performance.";
    if (!formFields.others) fieldErrors.othersError = "Enter Others.";
  
    if (!formFields.pf) fieldErrors.pfError = "Enter PF.";
    if (!formFields.esi) fieldErrors.esiError = "Enter ESI.";
    if (!formFields.insurance) fieldErrors.insuranceError = "Enter Insurance.";
    if (!formFields.loan) fieldErrors.loanError = "Enter Loan.";
    if (!formFields.tax) fieldErrors.taxError = "Enter Tax.";
  
    setFormFieldsError(fieldErrors);
    setErrors(commonErrors);   // <-- THIS is what DropDown reads
  
    return (
      Object.values(fieldErrors).every((x) => x === "") &&
      Object.values(commonErrors).every((x) => x === "")
    );
  };
  const handleSubmit = async (rowIndex, flag) => {
    setSubmitBtnDisabled(true);
    setIsLoading(true);
    
    try {
      if (flag === 1 || flag === 2) {
        const isValid = validateForm();
        if (!isValid) {
          setIsOpen(true);
          return;
        }
        setIsOpen(false);

        const data = {
          mstClientId: clientId,
          mstSalaryId: parseInt(MstSalaryId) || 0,
          grade: String(formFields.grade).trim(),
          basicSalary: Number(formFields.basicSalary) || 0,
          da: Number(formFields.da) || 0,
          hra: Number(formFields.hra) || 0,
          conveyance: Number(formFields.Conveyance) || 0,
          medical: Number(formFields.medical) || 0,
          performance: Number(formFields.performance) || 0,
          others: Number(formFields.others) || 0,
          grossSalaryTotal: Number(formFields.grossSalaryTotal) || 0,
          pf: Number(formFields.pf) || 0,
          esi: Number(formFields.esi) || 0,
          insurance: Number(formFields.insurance) || 0,
          loan: Number(formFields.loan) || 0,
          tax: Number(formFields.tax) || 0,
          deductionsTotal: Number(formFields.deductionTotal) || 0,
          netTotal: Number(formFields.netTotal) || 0,
          createdBy: Number(createdBy) || 0,
          flag: Number(flag),
        };

        const response = await IUDAPI(data, "SalaryMasterAPI/IUDSalaryMaster");
        const result = response?.data?.Table?.[0]?.Result || "";

        if (flag === 1 && result === "S") {
          toast.success("Grade data inserted successfully! 👍");
          cancel();
        } else if (flag === 2 && result === "M") {
          toast.success("Grade data modified successfully! 👍");
          cancel();
        } else {
          toast.error("Operation failed 👎");
        }
      } else {
        // For flags 3,4,5 (Delete, Block, Unblock)
        const data = {
          mstSalaryId: bindSalaryMasterData?.[rowIndex]?.MstSalaryId ?? 0,
          createdBy,
          flag,
        };

        const response = await IUDAPI(data, "SalaryMasterAPI/IUDSalaryMaster");
        const result = response?.data?.Table?.[0]?.Result || "";

        if (flag === 3 && result === "D") {
          toast.success("Grade data deleted successfully! 👍");
          cancel();
        } else if (flag === 4 && result === "B") {
          toast.success("Grade data inactivated successfully! 👍");
          cancel();
        } else if (flag === 5 && result === "UB") {
          toast.success("Grade data activated successfully! 👍");
          cancel();
        } else {
          toast.error("Operation failed 👎");
        }
      }
    } catch (error) {
      toast.error("Something went wrong 👎");
      console.error(error);
    } finally {
      setIsLoading(false);
      setSubmitBtnDisabled(false);
    }
  };

  // Show add form with default date
  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
  };
  // Cancel and reset views
  const cancel = () => {
    BindSalaryMaster();
    setVisibleAdd(false);
    setVisibleTable(true);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setformFields({
      grade: "",
      basicSalary: "",
      da: "",
      hra: "",
      Conveyance: "",
      medical: "",
      performance: "",
      others: "",
      grossSalaryTotal: "",
      pf: "",
      esi: "",
      insurance: "",
      loan: "",
      tax: "",
      deductionTotal: "",
      netTotal: "",
    });
    setErrors({}); // this is for general errors
    setFormFieldsError({
      // this is for field-level errors
      GradeError: "",
      basicSalaryError: "",
      daError: "",
      hraError: "",
      ConveyanceError: "",
      medicalError: "",
      performanceError: "",
      othersError: "",
      grossSalaryTotalError: "",
      pfError: "",
      esiError: "",
      insuranceError: "",
      loanError: "",
      taxError: "",
      deductionTotalError: "",
      netTotalError: "",
    });
    setpopUpOpen(false);
  };

  // Handle different popup actions (View/Delete/Block/Unblock)
  const handlesalary = (rowIndex, flag) => {
    setRowIndex(rowIndex);
    setpopUpOpen(true);

    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(true);
    }
    setMstSalaryId(bindSalaryMasterData[rowIndex].MstSalaryId);
    const grade = gradeDropdown.find(
      (item) => item.value === bindSalaryMasterData[rowIndex].Grade
    );

    const gradeValue = {
      value: bindSalaryMasterData[rowIndex].MstGradeId,
      label: grade ? grade.label : "Unknown",
    };
    setPopUpDataDD([gradeValue]);
    setPopUpData(bindSalaryMasterData[rowIndex]);
  };
  // Handle editing a row
  const handleEdit = (rowIndex) => {
    setRowIndex(rowIndex);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(true);
    setMstSalaryId(bindSalaryMasterData[rowIndex].MstSalaryId);
    setformFields({
      ...formFields,
      mstGradeId: bindSalaryMasterData[rowIndex].Grade,
      grade: bindSalaryMasterData[rowIndex].Grade,
      basicSalary: bindSalaryMasterData[rowIndex].BasicSalary,
      da: bindSalaryMasterData[rowIndex].DA,
      hra: bindSalaryMasterData[rowIndex].HRA,
      Conveyance: bindSalaryMasterData[rowIndex].Conveyance,
      medical: bindSalaryMasterData[rowIndex].Medical,
      performance: bindSalaryMasterData[rowIndex].Performance,
      others: bindSalaryMasterData[rowIndex].Others,
      grossSalaryTotal: bindSalaryMasterData[rowIndex].GrossSalaryTotal,
      pf: bindSalaryMasterData[rowIndex].PF,
      esi: bindSalaryMasterData[rowIndex].ESI,
      insurance: bindSalaryMasterData[rowIndex].Insurance,
      loan: bindSalaryMasterData[rowIndex].Loan,
      tax: bindSalaryMasterData[rowIndex].Tax,
      deductionTotal: bindSalaryMasterData[rowIndex].DeductionsTotal,
      netTotal: bindSalaryMasterData[rowIndex].NetTotal,
    });
  };
  const numericFields = [
    "basicSalary",
    "da",
    "hra",
    "Conveyance",
    "medical",
    "performance",
    "others",
    "grossSalaryTotal",
    "pf",
    "esi",
    "insurance",
    "loan",
    "tax",
    "deductionTotal",
    "netTotal",
  ];
  const calculateTotal = (fields) => {
    const {
      basicSalary = 0,
      da = 0,
      hra = 0,
      Conveyance = 0,
      medical = 0,
      performance = 0,
      others = 0,
      pf = 0,
      esi = 0,
      insurance = 0,
      loan = 0,
      tax = 0,
    } = fields;

    const grossSalaryTotal =
      Number(basicSalary || 0) +
      Number(da || 0) +
      Number(hra || 0) +
      Number(Conveyance || 0) +
      Number(medical || 0) +
      Number(performance || 0) +
      Number(others || 0);

    const pfAmount = (Number(grossSalaryTotal) * Number(pf || 0)) / 100;
    const esiAmount = (Number(grossSalaryTotal) * Number(esi || 0)) / 100;

    const insuranceAmount = Number(insurance || 0);
    const loanAmount = Number(loan || 0);
    const taxAmount = Number(tax || 0);

    const deductionTotal =
      pfAmount + esiAmount + insuranceAmount + loanAmount + taxAmount;

    const netTotal = grossSalaryTotal - deductionTotal;

    setformFields((prev) => ({
      ...prev,
      ...fields,
      grossSalaryTotal,
      deductionTotal,
      netTotal,
    }));
  };

  // Validate form fields on blur
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    const updatedFields = {
      ...formFields,
      [name]: value,
    };

    // Live calculation
    calculateTotal(updatedFields);

    // Validation
    const updatedErrors = { ...formFieldsError };

    if (numericFields.includes(name)) {
      if (!/^\d*\.?\d*$/.test(value)) {
        updatedErrors[`${name}Error`] = "Only numbers allowed";
      } else {
        updatedErrors[`${name}Error`] = "";
      }
    }

    if (name === "grade") {
      if (!value) {
        updatedErrors.grade = "Please select a Grade.";
      }
    }

    setFormFieldsError(updatedErrors);
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    const trimmedValue = String(value || "").trim(); // safe

    const formattedName = name.charAt(0).toUpperCase() + name.slice(1);
    let error = "";

    if (!trimmedValue) {
      error = `Enter the ${formattedName}.`;
    } else if (
      updateScreenTitle && name === "grade" &&
      formFields.mstGradeId == formFields.grade
      
    ) {
      error ="";
    }else if (
      name === "grade" &&
      bindGradeData.some(
        (item) =>
          String(item.Grade || "")
            .trim()
            .toLowerCase() === trimmedValue.toLowerCase() &&
          item.MstGradeId !== formFields.grade
      )
    ) {
      error = `${formattedName} already exists.`;
    }

    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  return (
    <MainLayout pageName={"2"}>
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        //Grid view section
        <GridPage
          header={GradeHeader}
          title={"Grade"}
          records={bindSalaryMasterData}
          handleEdit={handleEdit}
          handleAction={handlesalary}
          showAdd={showAdd}
          blockview={true}
        />
      )}

      <>
        {visibleAdd && (
          // Add or Update form section
          <div className="w-full">
            <div className="flex flex-col w-full">
              <div className={mainTable.clientMasterMainAdd}>
                <AddScreenTitle
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                  title="Grade"
                />
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 p-4 gap-4">
              <DropDown
                name="grade"
                title="Grade"
                type={"select-one"}
                options={gradeDropdown ?? []}
                classStar="text-red-500"
                controlFunc={handleInputChange}
                controlFuncBlur={handleBlur}
                selectedOption={formFields.grade}
                placeholder="Select Grade"
                // tabIndex="12"
                errorMessage={errors.grade}
              />
            </div>
            <div className="font-semibold px-4">Gross salary</div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 p-4 gap-4">
              <InputText
                title="Basic Salary"
                inputType="text"
                name="basicSalary"
                classStar="text-red-500"
                style={{ textAlign: "right" }}
                content={formFields.basicSalary}
                errorMessage={formFieldsError.basicSalaryError}
                controlFunc={handleInputChange}
                controlFuncBlur={() => {
                  const value = formFields.basicSalary;
                  let error = "";

                  if (!value) {
                    error = "Enter Basic Salary";
                  } else if (!/^\d*\.?\d*$/.test(value)) {
                    error = "Only valid numbers allowed";
                  }

                  setFormFieldsError((prev) => ({
                    ...prev,
                    basicSalaryError: error,
                  }));
                }}
                Class="border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block text-right w-full h-11 px-2 py-1"
              />

              <InputText
                title="DA"
                inputType="text"
                name="da"
                classStar="text-red-500"
                content={formFields.da}
                errorMessage={formFieldsError.daError}
                controlFunc={handleInputChange}
                controlFuncBlur={() => {
                  const value = formFields.da;
                  let error = "";

                  if (!value) {
                    error = "DA is required";
                  } else if (!/^\d*\.?\d*$/.test(value)) {
                    error = "Only valid numbers allowed";
                  }

                  setFormFieldsError((prev) => ({ ...prev, daError: error }));
                }}
                Class="border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block text-right w-full h-11 px-2 py-1"
              />

              <InputText
                title="HRA"
                inputType="text"
                name="hra"
                classStar="text-red-500"
                content={formFields.hra}
                errorMessage={formFieldsError.hraError}
                controlFunc={handleInputChange}
                controlFuncBlur={() => {
                  const value = formFields.hra;
                  let error = "";

                  if (!value) {
                    error = "HRA is required";
                  } else if (!/^\d*\.?\d*$/.test(value)) {
                    error = "Only valid numbers allowed";
                  }

                  setFormFieldsError((prev) => ({ ...prev, hraError: error }));
                }}
                Class="border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block text-right w-full h-11 px-2 py-1"
              />

              <InputText
                title="Conveyance"
                inputType="text"
                name="Conveyance"
                classStar="text-red-500"
                content={formFields.Conveyance}
                errorMessage={formFieldsError.ConveyanceError}
                controlFunc={handleInputChange}
                controlFuncBlur={() => {
                  const value = formFields.Conveyance;
                  let error = "";

                  if (!value) {
                    error = "Conveyance is required";
                  } else if (!/^\d*\.?\d*$/.test(value)) {
                    error = "Only valid numbers allowed";
                  }

                  setFormFieldsError((prev) => ({
                    ...prev,
                    ConveyanceError: error,
                  }));
                }}
                Class="border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block text-right w-full h-11 px-2 py-1"
              />

              <InputText
                title="Medical"
                inputType="text"
                name="medical"
                classStar="text-red-500"
                content={formFields.medical}
                errorMessage={formFieldsError.medicalError}
                controlFunc={(e) => {
                  const { value } = e.target;
                  setformFields((prev) => ({ ...prev, medical: value }));

                  if (!/^\d*\.?\d*$/.test(value)) {
                    setFormFieldsError((prev) => ({
                      ...prev,
                      medicalError: "Only numbers allowed",
                    }));
                  } else {
                    setFormFieldsError((prev) => ({
                      ...prev,
                      medicalError: "",
                    }));
                  }
                }}
                controlFuncBlur={() => {
                  const value = formFields.medical;
                  let error = "";

                  if (!value) {
                    error = "Medical is required";
                  } else if (!/^\d*\.?\d*$/.test(value)) {
                    error = "Only valid numbers allowed";
                  }

                  setFormFieldsError((prev) => ({
                    ...prev,
                    medicalError: error,
                  }));
                }}
                Class="border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block text-right w-full h-11 px-2 py-1"
              />

              <InputText
                title="Performance"
                inputType="text"
                name="performance"
                classStar="text-red-500"
                content={formFields.performance}
                errorMessage={formFieldsError.performanceError}
                controlFunc={handleInputChange}
                controlFuncBlur={() => {
                  const value = formFields.performance;
                  let error = "";

                  if (!value) {
                    error = "Performance is required";
                  } else if (!/^\d*\.?\d*$/.test(value)) {
                    error = "Only valid numbers allowed";
                  }

                  setFormFieldsError((prev) => ({
                    ...prev,
                    performanceError: error,
                  }));
                }}
                Class="border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block text-right w-full h-11 px-2 py-1"
              />

              <InputText
                title="Others"
                inputType="text"
                name="others"
                classStar="text-red-500"
                content={formFields.others}
                errorMessage={formFieldsError.othersError}
                controlFunc={handleInputChange}
                controlFuncBlur={() => {
                  const value = formFields.others;
                  let error = "";

                  if (!value) {
                    error = "Others is required";
                  } else if (!/^\d*\.?\d*$/.test(value)) {
                    error = "Only valid numbers allowed";
                  }

                  setFormFieldsError((prev) => ({
                    ...prev,
                    othersError: error,
                  }));
                }}
                Class="border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block text-right w-full h-11 px-2 py-1"
              />
              <InputText
                inputType="number"
                title="Total"
                name="grossSalaryTotal"
                classStar="text-red-500"
                className="text-right"
                controlFunc={handleInputChange}
                controlFuncBlur={() => {}}
                content={formFields.grossSalaryTotal}
                errorMessage={formFieldsError.grossSalaryTotal}
                disabled={true}
                Class="border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block text-right w-full h-11 px-2 py-1"
              />
            </div>
            <div className="font-semibold px-4 ">Deductions</div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 p-4 gap-4">
              <InputText
                inputType="text"
                title="PF"
                name="pf"
                classStar="text-red-500"
                content={formFields.pf}
                errorMessage={formFieldsError.pfError}
                icon={<span>%</span>}
                controlFunc={handleInputChange}
                controlFuncBlur={() => {
                  const value = formFields.pf;
                  let error = "";

                  if (!value) {
                    error = "PF is required";
                  } else if (!/^\d*\.?\d*$/.test(value)) {
                    error = "Only valid numbers allowed";
                  }

                  setFormFieldsError((prev) => ({ ...prev, pfError: error }));
                }}
                Class="border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block text-right w-full h-11 px-2 py-1"
              />

              <InputText
                inputType="text"
                title="ESI"
                name="esi"
                classStar="text-red-500"
                content={formFields.esi}
                errorMessage={formFieldsError.esiError}
                icon={<span>%</span>}
                controlFunc={handleInputChange}
                controlFuncBlur={() => {
                  const value = formFields.esi;
                  let error = "";

                  if (!value) {
                    error = "ESI is required";
                  } else if (!/^\d*\.?\d*$/.test(value)) {
                    error = "Only valid numbers allowed";
                  }

                  setFormFieldsError((prev) => ({ ...prev, esiError: error }));
                }}
                Class="border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block text-right w-full h-11 px-2 py-1"
              />

              <InputText
                inputType="text"
                title="Insurance"
                name="insurance"
                classStar="text-red-500"
                content={formFields.insurance}
                errorMessage={formFieldsError.insuranceError}
                controlFunc={handleInputChange}
                controlFuncBlur={() => {
                  const value = formFields.insurance;
                  let error = "";

                  if (!value) {
                    error = "Insurance is required";
                  } else if (!/^\d*\.?\d*$/.test(value)) {
                    error = "Only valid numbers allowed";
                  }

                  setFormFieldsError((prev) => ({
                    ...prev,
                    insuranceError: error,
                  }));
                }}
                Class="border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block text-right w-full h-11 px-2 py-1"
              />

              <InputText
                inputType="text"
                title="Loan"
                name="loan"
                style={{ textAlign: "right" }}
                classStar="text-red-500"
                content={formFields.loan}
                errorMessage={formFieldsError.loanError}
                controlFunc={handleInputChange}
                controlFuncBlur={() => {
                  const value = formFields.loan;
                  let error = "";

                  if (!value) {
                    error = "Loan is required";
                  } else if (!/^\d*\.?\d*$/.test(value)) {
                    error = "Only valid numbers allowed";
                  }

                  setFormFieldsError((prev) => ({ ...prev, loanError: error }));
                }}
                Class="border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block text-right w-full h-11 px-2 py-1"
              />

              <InputText
                inputType="text"
                title="Tax"
                name="tax"
                classStar="text-red-500"
                style={{ textAlign: "right" }}
                content={formFields.tax}
                errorMessage={formFieldsError.taxError}
                controlFunc={handleInputChange}
                controlFuncBlur={() => {
                  const value = formFields.tax;
                  let error = "";

                  if (!value) {
                    error = "Tax is required";
                  } else if (!/^\d*\.?\d*$/.test(value)) {
                    error = "Only valid numbers allowed";
                  }

                  setFormFieldsError((prev) => ({ ...prev, taxError: error }));
                }}
                Class="border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block text-right w-full h-11 px-2 py-1"
              />

              <InputText
                inputType="number"
                title="Total"
                name="deductionTotal"
                classStar="text-red-500"
                controlFunc={handleInputChange}
                controlFuncBlur={handleBlur}
                content={formFields.deductionTotal}
                errorMessage={errors.deductionTotal}
                disabled={true}
                Class="border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block text-right w-full h-11 px-2 py-1"
              />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 p-4 gap-4">
              <InputText
                inputType="number"
                title="Net Total (Gross salary Total - Deductions Total)"
                name="netTotal"
                classStar="text-red-500"
                controlFunc={handleInputChange}
                controlFuncBlur={handleBlur}
                content={formFields.netTotal}
                errorMessage={errors.netTotal}
                disabled={true}
                Class="border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block text-right w-full h-11 px-2 py-1"
              />
              <div className="flex justify-center mt-24">
                <Buttons
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                  disabledBtn={false}
                  viewSaveButton={false}
                  handleSubmit={handleSubmit}
                  cancel={cancel}
                />
              </div>
            </div>
          </div>
        )}     {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      </>
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handlesalary}
      >
        <div>
          <PopUpScreenTitle
            title="Grade"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <GradePopup data={popUpData} data1={popUpDataDD} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          handleSubmit={handleSubmit}
          cancel={cancel}
          rowIndex={rowIndex}
          disabledBtn={submitBtnDisabled}
        />
      </MainPopup>
    </MainLayout>
  );
};
export default Grade;
